import { ReactNode } from 'react';

// Container for the Header section
export const ModalHeader = ({ children, title }: { children?: ReactNode; title?: string }) => (
  <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
    {title ? (
      <h3 id="modal-title" className="text-lg font-semibold text-gray-900">
        {title}
      </h3>
    ) : (
      children
    )}
  </div>
);

// Container for the Main Body
export const ModalContent = ({ children }: { children: ReactNode }) => (
  <div className="px-6 py-4 overflow-y-auto max-h-[60vh]">{children}</div>
);

// Container for Actions (Buttons)
export const ModalActions = ({ children }: { children: ReactNode }) => (
  <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
    {children}
  </div>
);

// Helper to compose them easily if needed, or use individually
export const Modal = {
  Header: ModalHeader,
  Content: ModalContent,
  Actions: ModalActions,
};
